import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent, useContext, useMemo } from 'react';
import { EmbedLink } from '../../../../../../components';
import { UserContext } from '../../../../../../context';
import { getDeepLinkUrl } from '../../../../../utils';
import { DeeplinkType } from '../../../../Deeplink';
import { CloseWrapper, useBlockToolInputFocus } from '../../helpers';
import { StoryNodeSelect } from '../StoryNodeSelect';

export const StoryNodeView: FunctionComponent<NodeViewProps> = ({
  editor,
  node,
  getPos,
  updateAttributes,
}) => {
  const { channelId } = useContext(UserContext).userInfo.userData;

  const { onBlockInputFocus } = useBlockToolInputFocus({ editor, getPos });

  const content = useMemo(() => {
    const { story } = node.attrs;

    if (story) {
      const { id: storyId, title, subtitle: text, image } = story;

      const url = getDeepLinkUrl({ type: DeeplinkType.STORY, channelId, storyId });

      return <EmbedLink link={{ url, title, text, image }} hideUrl />;
    }

    return (
      <StoryNodeSelect
        story={story}
        setStory={(story) => updateAttributes({ story })}
        onFocus={onBlockInputFocus}
      />
    );
  }, [channelId, node.attrs, onBlockInputFocus, updateAttributes]);

  return (
    <NodeViewWrapper>
      <CloseWrapper editor={editor} node={node} getPos={getPos}>
        {content}
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
